import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  max-height: ', 'px;\n  opacity: ', ';\n  overflow: ', ';\n  transition: max-height 0.3s, opacity 0.3s;\n'], ['\n  max-height: ', 'px;\n  opacity: ', ';\n  overflow: ', ';\n  transition: max-height 0.3s, opacity 0.3s;\n']);

import styled from 'styled-components';

export default styled.div(_templateObject, function (_ref) {
  var isExpanded = _ref.isExpanded;
  return isExpanded ? 150 : 0;
}, function (_ref2) {
  var isExpanded = _ref2.isExpanded;
  return isExpanded ? 1 : 0;
}, function (_ref3) {
  var isExpanded = _ref3.isExpanded;
  return isExpanded ? 'visible' : 'hidden';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/flag/dist/esm/components/Expander/styledExpander.js
// module id = 465
// module chunks = 0